import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=4317072c&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=4317072c&prod&lang=css"
import style1 from "./Privacy.vue?vue&type=style&index=1&id=4317072c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4317072c",
  null
  
)

export default component.exports